// import { PrimaryButton } from "@/components/buttons/PrimaryButton"
// import { PencomRoutes } from "@/router/PencomRoutes"
import { useState } from "react"
// import { useNavigate } from "react-router-dom"

export interface Provider {
    id: string
    name: string
    description: string
    address: string
    website: string
    icon: string
}

const getSafeHttpsUrlFromWebsite = (website: string): string | null => {
    const input = website?.trim();
    if (!input) return null;

    // Reject whitespace/control chars to avoid weird parsing.
    if (/\s/.test(input)) return null;

    // Reject dangerous schemes.
    if (/^(javascript:|data:|vbscript:)/i.test(input)) return null;

    // Normalize: remove any scheme and leading "//", then build an https URL.
    const normalized = input
        .replace(/^https?:\/\//i, "")
        .replace(/^\/\//, "");

    // Reject userinfo/credentials injection attempts.
    if (normalized.includes("@")) return null;

    try {
        const u = new URL(`https://${normalized}`);
        if (u.protocol !== "https:") return null;
        if (!/^[a-zA-Z0-9.-]+$/.test(u.hostname)) return null;
        return u.toString();
    } catch {
        return null;
    }
};

const providers: Provider[] = [
    {
        id: "anchor",
        name: "Anchor Insurance Company Ltd",
        description: "Anchor Insurance Company Ltd offers comprehensive group life insurance solutions designed to protect employees and their families while helping employers meet regulatory requirements.",
        address: "Plot 5A, Ayo Jagun Street, Lekki Phase 1, Lagos",
        website: "www.anchorinsurance.ng",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "capital-express",
        name: "Capital Express Indemnity Insurance Ltd",
        description: "Capital Express Indemnity Insurance Ltd provides reliable group life insurance products with competitive rates and excellent customer service.",
        address: "17, Bishop Kale Close, off Kasumu Ekemode Street, Victoria Island, Lagos",
        website: "www.ceiil.ng",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "consolidated-hallmark",
        name: "Consolidated Hallmark Insurance Plc",
        description: "Consolidated Hallmark Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "266 Moshood Abiola Way (formerly Ikorodu Road), Obanikoro, Lagos",
        website: "www.ch-insure.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "coronation",
        name: "Coronation Insurance Ltd",
        description: "Coronation Insurance Ltd provides innovative insurance solutions including group life insurance with a customer-centric approach.",
        address: "No. 199, Awolowo Road, Ikoyi, Lagos",
        website: "www.coronation.ng/institus/coronation-insurance/",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "custodian-allied",
        name: "Custodian & Allied Insurance Ltd",
        description: "Custodian & Allied Insurance Ltd specializes in life insurance products including group life insurance with flexible coverage options.",
        address: "16A, Commercial Avenue, Sabo, Yaba, Lagos",
        website: "www.custodianplc.com.ng",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "emple",
        name: "emPle General Insurance Company Nigeria Ltd",
        description: "emPle General Insurance Company Nigeria Ltd offers reliable group life insurance products tailored for employers.",
        address: "4th Floor, Plot 1297, Akin Adesola Street, Victoria Island, Lagos",
        website: "www.emple.group",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "fin",
        name: "Fin Insurance Company Ltd",
        description: "Fin Insurance Company Ltd provides comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "No. 34 Gana Street, Maitama, FCT Abuja",
        website: "www.finsurance.com.ng",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "guinea",
        name: "Guinea Insurance Plc",
        description: "Guinea Insurance Plc offers reliable group life insurance products with competitive rates and excellent customer service.",
        address: "No. 33, Ikorodu Road, Jibowu, Lagos",
        website: "www.guineainsurance.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "heirs",
        name: "Heirs Insurance Ltd",
        description: "Heirs Insurance Ltd provides innovative insurance solutions including group life insurance with comprehensive coverage options.",
        address: "Heirs Insurance Towers, Plot 107B, Ajose Adeogun Street, Victoria Island, Lagos",
        website: "www.heirsinsurancegroup",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "international-energy",
        name: "International Energy Insurance Plc",
        description: "International Energy Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "Plot 294, Jide Oki Street, off Ligali Ayorinde Street, Victoria Island, Lagos",
        website: "www.ieiplcng.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "kbl",
        name: "KBL Insurance Ltd",
        description: "KBL Insurance Ltd provides reliable group life insurance products with competitive rates and excellent customer service.",
        address: "Block 138, Plot 5, Gabriel Olusanya Street, Lekki Phase 1, Lagos",
        website: "www.kblinsurance.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "linkage",
        name: "Linkage Assurance Plc",
        description: "Linkage Assurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "Linkage Plaza, Plot 20 Block 94, Lekki–Epe Expressway, Victoria Island, Lagos",
        website: "www.linkageassurance.co",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "mutual-benefits",
        name: "Mutual Benefits Assurance Plc",
        description: "Mutual Benefits Assurance Plc offers reliable group life insurance products with competitive rates and excellent customer service.",
        address: "Aret Adams House, 233 Ikorodu Road, Ilupeju, Lagos",
        website: "www.mutualng.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "nem",
        name: "NEM Insurance Plc",
        description: "NEM Insurance Plc provides comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "199 Ikorodu Road, Obanikoro, Lagos",
        website: "www.nem-insurance.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "naic",
        name: "Nigerian Agricultural Insurance Corporation (NAIC)",
        description: "Nigerian Agricultural Insurance Corporation (NAIC) offers specialized insurance solutions including group life insurance.",
        address: "Plot 590, Zone A.O., Central Area, P.M.B. 0178, Abuja",
        website: "www.naic.gov.ng",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "npf",
        name: "NPF Insurance Co. Ltd",
        description: "NPF Insurance Co. Ltd provides reliable group life insurance products with competitive rates and excellent customer service.",
        address: "Behind Louis Edet House, Force Headquarters, Area 11, Garki, Abuja",
        website: "www.npfinsurance.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "prestige",
        name: "Prestige Assurance Plc",
        description: "Prestige Assurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "19 Ligali Ayorinde Street, Victoria Island, Lagos",
        website: "www.prestigeassurancep",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "regency",
        name: "Regency Alliance Insurance Plc",
        description: "Regency Alliance Insurance Plc provides innovative insurance solutions including group life insurance with comprehensive coverage options.",
        address: "2 Ebun Street, Gbagada Expressway, Gbagada, Lagos",
        website: "www.regencyalliance.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "rex",
        name: "REX Insurance Ltd",
        description: "REX Insurance Ltd offers reliable group life insurance products with competitive rates and excellent customer service.",
        address: "26E Abdulrahman Okene Close, off Ligali Ayorinde Street, Victoria Island, Lagos",
        website: "www.rexinsure.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "sanlam",
        name: "Sanlam (Allianz General Insurance Nigeria Ltd)",
        description: "Sanlam (Allianz General Insurance Nigeria Ltd) provides comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "298 Ikorodu Road, Anthony, Lagos",
        website: "www.sanlam.com.ng/corp",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "sovereign",
        name: "Sovereign Trust Insurance Plc",
        description: "Sovereign Trust Insurance Plc offers reliable group life insurance products with competitive rates and excellent customer service.",
        address: "17 Adetokunbo Ademola Street, Victoria Island, Lagos",
        website: "www.stiplc.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "staco",
        name: "Staco Insurance Plc",
        description: "Staco Insurance Plc provides comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "209 Herbert Macaulay Street, Ebute Metta, Lagos",
        website: "www.portals.stacoplc.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "sterling",
        name: "Sterling Assurance Nigeria Ltd",
        description: "Sterling Assurance Nigeria Ltd offers reliable group life insurance products with competitive rates and excellent customer service.",
        address: "Sterling House, 284 Ikorodu Road, Anthony, Lagos",
        website: "www.sterlingassure.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "sunu",
        name: "Sunu Assurances Plc",
        description: "Sunu Assurances Plc provides comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "Plot 1196, Bishop Oluwole Street, Victoria Island, Lagos",
        website: "www.sunuassurancesnige",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "tangerine",
        name: "Tangerine General Insurance Ltd",
        description: "Tangerine General Insurance Ltd offers innovative insurance solutions including group life insurance with comprehensive coverage options.",
        address: "House 14, Hughes Avenue, Alagbomeji, Yaba, Lagos",
        website: "www.general.tangerine.af",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "unitrust",
        name: "Unitrust Insurance Nigeria Ltd",
        description: "Unitrust Insurance Nigeria Ltd provides reliable group life insurance products with competitive rates and excellent customer service.",
        address: "Plot 105B, Ajose Adeogun Street, Victoria Island, Lagos",
        website: "www.unitrustinsurance.co",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "universal",
        name: "Universal Insurance Plc",
        description: "Universal Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
        address: "No. 11A, Ligali Ayorinde Street, Victoria Island, Lagos",
        website: "www.universalinsurancep",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "veritas",
        name: "Veritas Kapital Assurance Plc",
        description: "Veritas Kapital Assurance Plc provides innovative insurance solutions including group life insurance with comprehensive coverage options.",
        address: "Plot 497, Abogo Largema Street, off Constitution Avenue, CBD, Abuja",
        website: "www.veritaskapital.com",
        icon: "/assets/icons/building.svg"
    },
    {
        id: "zenith",
        name: "Zenith General Insurance Company Ltd",
        description: "Zenith General Insurance Company Ltd offers reliable group life insurance products with competitive rates and excellent customer service.",
        address: "Plot 280, Ajose Adeogun Street, Victoria Island, Lagos",
        website: "www.zenithinsurance.com",
        icon: "/assets/icons/building.svg"
    }
]

export const AvailableProvidersPage = () => {
    // const navigate = useNavigate();
    const [expandedProvider, setExpandedProvider] = useState<string | null>("anchor")

    const toggleProvider = (providerId: string) => {
        setExpandedProvider(expandedProvider === providerId ? null : providerId)
    }

    // const handleRequestCallBack = (provider: Provider) => {
    //     navigate(PencomRoutes.REQUEST_CALL_BACK, { state: { provider } })
    // }

    return <div className="w-full flex flex-col min-h-screen">
        <div className="w-full flex flex-col  max-w-[620px] mx-auto mt-6">
            <div className="flex flex-col items-center justify-center">
                <p className="font-semibold text-2xl font-clash-display text-medium-dark-grey">Get Group Life Insurance</p>
            </div>
            <div className="mt-8 bg-white border border-stroke rounded-2xl p-6">
                <h3 className="font-semibold text-sm font-clash-display text-medium-dark-grey">What is Group Life Insurance?</h3>
                <div className="mt-4 gap-y-2 flex flex-col">
                    <p className="font-regular text-sm font-clash-display text-medium-dark-grey">Group life insurance is a single contract that provides life insurance coverage to a group of people, typically the employees of a company. Instead of individuals purchasing separate policies, the employer buys a master policy that covers all eligible members of the group.</p>
                    <p className="font-regular text-sm font-clash-display text-medium-dark-grey">The coverage is usually offered as a benefit to employees, and the premium is often paid entirely by the employer, though some plans may require employee contributions. This type of insurance is generally more affordable than individual policies and often doesn't require a medical exam. It provides a financial payout to the beneficiaries of a covered employee if they pass away while employed by the company.</p>
                </div>
            </div>
            <div className="mt-6 bg-white border border-stroke rounded-2xl ">
                <div className="px-6 py-4">
                    <h3 className="font-semibold text-sm font-clash-display text-medium-dark-grey">Available Providers</h3>
                </div>
                <div className=" flex flex-col">
                    {providers.map((provider, index) => (
                        <div key={provider.id}>
                            <div
                                className="flex items-center p-4 justify-between py-4 cursor-pointer"
                                onClick={() => toggleProvider(provider.id)}
                            >
                                <div className="flex flex-row items-center gap-3 justify-center">
                                    <img src={provider.icon} alt="" className="w-8 h-8" />
                                    <span className="font-medium text-sm font-clash-display text-medium-dark-grey">
                                        {provider.name}
                                    </span>
                                </div>
                                <div className="text-black">
                                    {expandedProvider === provider.id ? (
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18 15L12 9L6 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    ) : (
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    )}
                                </div>
                            </div>

                            {expandedProvider === provider.id && (
                                <div className="mb-4 px-14">
                                    <p className="font-regular text-sm font-clash-display text-medium-dark-grey mb-4">
                                        {provider.description}
                                    </p>
                                    <div className="mb-4 flex flex-col gap-2">
                                        <div>
                                            <span className="font-semibold text-sm font-clash-display text-medium-dark-grey">Address: </span>
                                            <span className="font-regular text-sm font-clash-display text-medium-dark-grey">{provider.address}</span>
                                        </div>
                                        <div>
                                            <span className="font-semibold text-sm font-clash-display text-medium-dark-grey">Website: </span>
                                            {getSafeHttpsUrlFromWebsite(provider.website) ? (
                                                <a
                                                    href={getSafeHttpsUrlFromWebsite(provider.website) ?? "#"}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="font-regular text-sm font-clash-display text-blue-600 hover:underline"
                                                >
                                                    {provider.website}
                                                </a>
                                            ) : (
                                                <span className="font-regular text-sm font-clash-display text-medium-dark-grey">
                                                    —
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    {/* <PrimaryButton title="Request Call Back" onClick={() => handleRequestCallBack(provider)} /> */}
                                </div>
                            )}

                            {index < providers.length - 1 && (
                                <div className="border-b border-gray-200"></div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
}